import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-parlor-green-dark text-parlor-cream/70 py-12 border-t border-parlor-gold/10">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">
        
        <div className="flex items-center gap-2 font-serif text-xl text-parlor-cream">
          <SafeIcon icon="Camera" className="text-parlor-gold" />
          MAGNET PARLOR
        </div>

        <div className="flex gap-6 text-sm uppercase tracking-widest">
          <a href="#" className="hover:text-parlor-gold transition-colors">Instagram</a>
          <a href="#" className="hover:text-parlor-gold transition-colors">Facebook</a>
          <a href="#" className="hover:text-parlor-gold transition-colors">Pinterest</a>
        </div>

        <div className="text-xs text-parlor-cream/40">
          &copy; {new Date().getFullYear()} Magnet Parlor. All rights reserved.
        </div>

      </div>
    </footer>
  );
};

export default Footer;